export const camelize = function(str) {

    if (!str) {
        return ""
    }

    if (!str.includes(" ")) {
        return str.toLowerCase();
    }

    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
};

export function uncamelize(str) {
    // Replace all capital letters by separator followed by lowercase one
    str = str.replace(/[A-Z]/g, function (letter) {
      return ' ' + letter.toLowerCase();
    });
    return str.replace("/^ /", '');
  }


export const snakeCase = function(str) {

    if (!str) {
        return ""
    }

    if (!str.includes(" ")) {
        return str.toLowerCase();
    }

    return str.replace(/\W+/g, " ")
      .split(/ |\B(?=[A-Z])/)
      .map(word => word.toLowerCase())
      .join('_');
};


export const titleCase = function(phrase) {
    return phrase.split(' ')
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
};

export const isEmpty = function(obj) {
    return Object.keys(obj).length === 0;
}

export const getProperties = function(...props) {
    return function(obj) {
        const newObj = {};
        props.forEach(name => {
          newObj[name] = obj[name];
        });
        
        return newObj;
    }
}